import React from 'react';
import { cn } from '../../utils/cn';
import { isWhiteLabel } from '../../config/tenantConfig';

export interface SegmentedOption {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
  title?: string;
}

interface SegmentedControlProps {
  value: string;
  onChange: (next: string) => void;
  options: SegmentedOption[];
  size?: 'sm' | 'md';
  fullWidth?: boolean;
  className?: string;
}

const SegmentedControl: React.FC<SegmentedControlProps> = ({
  value,
  onChange,
  options,
  size = 'md',
  fullWidth = false,
  className,
}) => {
  const wl = isWhiteLabel();
  const activeBg = wl ? 'bg-zebu-600' : 'bg-blue-600';

  const sizeCls = size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm';

  return (
    <div
      className={cn(
        'flex rounded-lg overflow-hidden border border-gray-300 dark:border-gray-600',
        className,
      )}
    >
      {options.map((opt, i) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => !opt.disabled && onChange(opt.value)}
            disabled={opt.disabled}
            title={opt.title}
            className={cn(
              'font-medium transition-colors',
              sizeCls,
              fullWidth && 'flex-1',
              i > 0 && 'border-l border-gray-300 dark:border-gray-600',
              active
                ? `${activeBg} text-white`
                : opt.disabled
                ? 'bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500 cursor-not-allowed'
                : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600',
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
